import { render, staticRenderFns } from "./SelectBonusReasons.vue?vue&type=template&id=1f8499d0"
import script from "./SelectBonusReasons.vue?vue&type=script&lang=js"
export * from "./SelectBonusReasons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports